import Axios from 'axios';

import Env from './Env';

import { SetStatusGlobal } from "../interface/Global";
import { SetListDataSingle } from '../interface/Data';

import { ReturnIndex } from './Function';

interface ListDataResponse {
    status_data     : boolean;
    index?          : any,
    administrators? : any,
    clients?        : any,
    projects?       : any,
    updates?        : any
}

function CloseLoading(){
    setTimeout(() => {
        SetStatusGlobal('loading', false);
    }, 200);
}

export async function ListDataPage(retries = 5): Promise<void> {
    ReturnIndex();
    SetStatusGlobal('loading', true);

    const pageStorage = localStorage.getItem('page')?.split('_')[0];
    const namePage    = (!pageStorage || pageStorage === 'undefined') ? 'index' : pageStorage;

    try {
        const response = await Axios.post<ListDataResponse>(Env.apiUrl, {
            type_page: 'list_data',
            token: localStorage.getItem('token'),
            page: namePage
        });
        
        console.log("response.data - " + namePage, response.data)
        
        if(response.data.status_data){
            if(response.data.index){
                SetListDataSingle('index', response.data.index);
            }
            if(response.data.administrators){
                SetListDataSingle('administrators', response.data.administrators);
            }
            if(response.data.clients){
                SetListDataSingle('clients', response.data.clients);
            }
            if(response.data.projects){
                SetListDataSingle('projects', response.data.projects);
            }
            if(response.data.updates){
                SetListDataSingle('updates', response.data.updates);
            }
            CloseLoading();

        }else if(retries > 0) {
            return ListDataPage(retries - 1);
        }else {
            CloseLoading();
        }
    }catch (error){
        if(retries > 0){
            return ListDataPage(retries - 1);
        }
        CloseLoading();
    }
}